import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "assets/logos/myOUTFRONT.png";
import logo1 from "assets/logos/myOUTFRONT.webp";
// import settingsIcon from "assets/icons/Admin.png"
import "./styles.css";
import { AuthenticatedTemplate, useIsAuthenticated } from "@azure/msal-react";
import { logoutSuccess, setLoading, setLoadingMessage } from "reduxStore/features/authSlice";
import { msalInstance } from "index";
import { Avatar, Button, Dropdown } from "antd";
import { UserOutlined } from "@ant-design/icons";

const Header = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated()
  const handleLogout = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingMessage("Signing Out"))
      await msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount(),
        postLogoutRedirectUri: "/"
      })
      dispatch(logoutSuccess());
    } catch (error) {
      console.log(error);
    }
  };

  const handleContact = (e) => {
    e?.preventDefault?.();
    window.location.href = "mailto:customer.care@outfront.com"
  }
  return (
    <div id="header">
      <nav>
        <Link to="/">
          <img
            className="logo"
            src={`${logo} 768w`}
            srcSet={`${logo1} 450w,${logo} 768w`}
            sizes="(min-width:450px) 450px,(min-width:768px) 768px"
            alt="myOUTFRONT.com"
          />
        </Link>
        <div className="wrapper">
          <AuthenticatedTemplate>
            <span className="btn logoutBtn" onClick={handleLogout}>
              Logout
            </span>
          </AuthenticatedTemplate>
          <Button className="btn" onClick={handleContact}>
            Contact Us
          </Button>
        </div>
        <span className="mobileDropdown">
          <CustomDropdown handleLogout={handleLogout} handleContact={handleContact} isAuthenticated={isAuthenticated} />
        </span>
      </nav>
    </div>
  );
};

export default Header;

const CustomDropdown = ({ handleLogout, handleContact, isAuthenticated }) => {
  const items = [
    {
      label: "Contact Us",
      key: 1,
      onClick: handleContact,
    },
    ...(isAuthenticated ? [
      {
        label: "Logout",
        key: 2,
        onClick: handleLogout,
      }
    ] : []),
  ];
  return (
    <Dropdown menu={{ items }}>
      <Avatar style={{ backgroundColor: "var(--purple500)" }} icon={<UserOutlined />} />
    </Dropdown>
  );
};
